import styled from '@emotion/styled';

import { colors } from 'theme/colors';

export const StyledCard = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  align-content: space-between;
  min-width: fit-content;
  border: 1px solid ${colors.primary50};
  border-radius: 4px;
  overflow: hidden;
  .MuiTypography-root {
    color: ${colors.primary900};
  }
`;

export const StyledHeader = styled.div`
  background-color: ${colors.primary50};
  padding: 12px 16px;
  height: 48px;
`;

export const StyledTableContainer = styled.div`
  background-color: ${colors.white};
`;

export const StyledTable = styled.table`
  width: 100%;
  padding: 14px 20px;
  border-collapse: collapse;
`;

export const StyledTh = styled.th<{ left?: boolean }>`
  text-align: ${(props: any) => (props.left ? 'left' : 'right')};
  color: ${colors.primary900};
  font-weight: 400;
  padding-top: 14px;
  padding-bottom: 4px;
`;

export const StyledThead = styled.thead`
  font-size: 14px;
`;
export const StyledRow = styled.tr``;
export const StyledTbody = styled.tbody`
  font-size: 14px;
`;

export const StyledTd = styled.td<{ left?: boolean }>`
  color: ${colors.primary900};
  text-align: ${(props: any) => (props.left ? 'left' : 'right')};
  padding-top: 4px;
  padding-bottom: 4px;
`;

export const StyledTotalRow = styled.tr`
  background-color: ${colors.primary15};
`;

export const StyledTotalTd = styled.td<{ isLabel?: boolean; left?: boolean }>`
  padding-top: 12px;
  padding-bottom: 12px;
  color: ${colors.primary900};
  font-weight: ${(props: any) => (props.isLabel ? 400 : 900)};
  text-align: ${(props: any) => (props.left ? 'left' : 'right')};
`;

export const StyledEmptyHeaderRow = styled.tr`
  height: 38px;
  padding-top: 14px;
  padding-bottom: 4px;
`;
